import { createLucideIcon } from 'lucide-react';

/**
 * Email and SMS counterparts of lucide's PhoneIncoming / PhoneOutgoing, so every
 * activity row reads direction the same way. The envelope and bubble keep their
 * full lucide size with the bottom-right corner left open for a diagonal arrow:
 * ↙ for received, ↗ for sent. The arrow takes the call direction colors (blue
 * inbound, green outbound) while the glyph keeps its channel color.
 */

const INCOMING_ARROW = [
  ['polyline', { points: '16 16 16 22 22 22', className: 'call-stroke-inbound', key: 'in-head' }],
  [
    'line',
    { x1: '22', x2: '16', y1: '16', y2: '22', className: 'call-stroke-inbound', key: 'in-shaft' },
  ],
] as const;

const OUTGOING_ARROW = [
  ['polyline', { points: '16 16 22 16 22 22', className: 'call-stroke-outbound', key: 'out-head' }],
  [
    'line',
    { x1: '16', x2: '22', y1: '22', y2: '16', className: 'call-stroke-outbound', key: 'out-shaft' },
  ],
] as const;

const ENVELOPE = [
  ['path', { d: 'M12 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5', key: 'env-body' }],
  ['path', { d: 'm3 7 9 6 9-6', key: 'env-flap' }],
] as const;

const BUBBLE = [
  ['path', { d: 'M12 17H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6', key: 'bubble' }],
] as const;

type IconNode = Parameters<typeof createLucideIcon>[1];

export const MailIncoming = createLucideIcon('MailIncoming', [
  ...ENVELOPE,
  ...INCOMING_ARROW,
] as unknown as IconNode);

export const MailOutgoing = createLucideIcon('MailOutgoing', [
  ...ENVELOPE,
  ...OUTGOING_ARROW,
] as unknown as IconNode);

export const MessageIncoming = createLucideIcon('MessageIncoming', [
  ...BUBBLE,
  ...INCOMING_ARROW,
] as unknown as IconNode);

export const MessageOutgoing = createLucideIcon('MessageOutgoing', [
  ...BUBBLE,
  ...OUTGOING_ARROW,
] as unknown as IconNode);
